import { ActionTypes } from "../constants";
import { combineReducers } from "redux";

const reduceLaunchURLs = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.RETAKE_TMS_MODULE_SUCCESS:
        case ActionTypes.UPDATE_TMS_MODULE_ENROLMENT_SUCCESS:
            return {
                ...state,
                [action.payload.id]: null
            };
        case ActionTypes.GET_TMS_LAUNCH_URL_SUCCESS:
            return {
                ...state,
                [action.payload.moduleId]: (action.data && action.data.launchURL) || ''
            };
        case ActionTypes.GET_TMS_LAUNCH_URL_FAILURE:
            return {
                ...state,
                [action.payload.moduleId]: ''
            };

        default:
            return state;
    }
};

const reduceErrors = (state = {}, action) => (
    action.type !== ActionTypes.GET_TMS_LAUNCH_URL_FAILURE ? state : ({
        ...state,
        [action.payload.moduleId]: { code: action.code, message: action.message }
    })
);

const launchURLs = combineReducers({
    launchURLs: reduceLaunchURLs,
    errors: reduceErrors
});

export const getByModule = ({launchURLs}, moduleId) => launchURLs.hasOwnProperty(moduleId) ? launchURLs[moduleId] : null;
export const getErrors = ({errors}, moduleId) => errors[moduleId] || null;

export default launchURLs;
